import React from 'react';
import Link from 'next/link';
import Styles from './styles.js';
const FindProperty = props => {
  const data = props;
  
  return (
    <div>
      <div className="w-full ">
        <div className="lg:container mx-auto px-6 lg:px-4 bg-white">
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-x-12 pb-12 pt-4 ">
            <div  className="md:mt-1  md:px-3  ">{data.img}</div>
            <div
              className={
                data.spacing
                  ? 'flex flex-col justify-end pt-3 md:pt-5 lg:pt-0 md:px-3 mb-6 '
                  : 'flex flex-col justify-end pt-5 lg:pt-0  md:px-3 mb-6  '
              }>
              {data.tagLine ? (
                <p className="fs-14-16 mt-2 pt-6 mb-4" style={{ fontFamily: 'Josefin Sans', color: '#5E5E5E' }}>
                  {data.tagLine}
                </p>
              ) : null}

              <h1 className="res-fs-size fw-400 pt-1 mb-2" style={{ fontFamily: 'Fjalla One', color: '#1B1B1B' }}>
                {data.title}
              </h1>
              {data.description}
              <div className={data.bottomSpace ? 'md:mt-3 mb-4 md:mb-0 md:pt-1 mt-2' : 'md:mt-3 md:pt-1 mt-2'}>
                {data.href ? (
                  <Link href={data.href}>
                    <button
                      type="button"
                      className="btn fw-600 fs-16-18 rounded-0  "
                      style={{
                        fontFamily: 'Josefin Sans',
                        color: '#010101',
                        backgroundColor: '#FCBD00',
                        padding: '14px 32px',
                      }}>
                      {data.btnTitle}
                    </button>
                  </Link>
                ) : (
                  <button
                    type="button"
                    className="btn fw-600 fs-16-18 rounded-0  "
                    style={{
                      fontFamily: 'Josefin Sans',
                      color: '#010101',
                      backgroundColor: '#FCBD00',
                      padding: '14px 32px',
                    }}>
                    {data.btnTitle}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Styles/>
    </div>
  );
};

export default FindProperty;
